import { ReactNode } from "react";
import { PageActionButtonProps, PageContentProps } from "../props";
import { usePageStyles } from "./styles";
import Control from "../../vfx/controls/control";
import { StringHelper } from "../../utils/helpers";
import { IPageStyles } from "../styles";

export const PageContent = (props: PageContentProps) => {
    const styles : IPageStyles = usePageStyles();
    
    const actionbuttons = (): PageActionButtonProps[] => {
        if (props.actionbuttons === null || props.actionbuttons === undefined || props.actionbuttons.length <= 0) {
            return [];
        }

        const items: PageActionButtonProps[] = [];
        props.actionbuttons.filter(item => item.onClick !== null && item.onClick !== undefined).map((item: PageActionButtonProps) => {
            item.image_style = item.image_style ?? styles.actionButton;
            items.push(item);
        })

        return items;
    }

    const hasHeader =
        !props.hideHeader &&
        (actionbuttons().length > 0 ||
            !StringHelper.isNullOrEmpty(props.title) ||
            props.onNew != null);

    if (!hasHeader && !props.hideHeader) {
        return null;
    }

    return (
        <div className="pt-4 px-4" style={styles.pageContainer}>
            {hasHeader && (
                <div className="container-fluid d-flex justify-content-between border-bottom pb-2 mb-3">
                    {props.title && (
                        <div className="mb-2">
                            <h1 className="ms-2" style={styles.pageTitle}>{props.title}</h1>
                            {props.subtitle && (
                                <span className="ms-2" style={styles.pageSubtitle}>{props.subtitle}</span>
                            )}
                        </div>
                        
                    )}
                    {actionbuttons() && (
                        <div>
                            {actionbuttons().map((item: PageActionButtonProps, index: number) => (
                                <PageActionButton key={"page_action_button_" + index} {...item} />
                            ))}
                        </div>
                    )}
                    {props.onNew && (
                        <div className="ml-auto">
                            <Control.Button
                                className="btn jump-on-hover"
                                style={{ ...styles.newButton }}
                                onClick={props.onNew}
                                type="button"
                            >
                                <span className="bi bi-plus" style={styles.newButtonIcon}></span>New
                            </Control.Button>
                        </div>
                    )}
                </div>
            )}
            <div className="pt-3 px-md-5 px-sm-1">
                {props.children}
            </div>
        </div>
    );
};

function formatButton(props: PageActionButtonProps): ReactNode {
    if (props.display_type === "image-only" || props.text === undefined) {
        return (
            <i className={props.image} style={props.image_style}></i>
        )
    }

    if (props.display_type === "image-before-text") {
        return (
            <span>
                <i className={props.image + " me-3"} style={props.image_style}></i>
                {props.text}
            </span>
        )
    }

    if (props.display_type === "image-after-text") {
        return (
            <span>
                {props.text}
                <i className={props.image + " ms-3"} style={props.image_style}></i>
            </span>
        )
    }

    return (
        <span> {props.text} </span>
    )
}

const PageActionButton: React.FC<PageActionButtonProps> = (props) => {
    const buttonClass = "btn " + (props.button_class ?? "");
    return (
        < Control.Button {...props} className={buttonClass}>
            {formatButton(props)}
        </Control.Button>
    );
};
